import { render } from "./Breadcrumbs.vue?vue&type=template&id=2b3476dd&scoped=true&ts=true"
import script from "./Breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./Breadcrumbs.vue?vue&type=script&lang=ts"

import "./Breadcrumbs.vue?vue&type=style&index=0&id=2b3476dd&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3476dd"]])

export default __exports__